<template>
    <div>
        <a-modal title="选择类名" :visible="isShow" width="700px" @cancel="handleCancel">

            <a-input-search style="width: 100%;margin-bottom:10px;" default-value="" :id="currentAppSelectSearchInput"  @search="onSearch" />

            <a-table :row-selection="{ selectedRowKeys: selectedRowKeys , onChange: onSelectChange ,type:'radio'}" :columns="columns"
                :data-source="list" rowKey="classname" :pagination="false" :scroll="{ x: 560}">
                <template slot="domainNames" slot-scope="text">
                    <span>{{ domainName[text] }}</span>
                </template>
            </a-table>

            <br />

            <a-pagination v-model="pagination.current" :total="pagination.total" @change="handlePageChange"
                style="float:right;" show-less-items />
            <br />

            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    取消
                </a-button>
                <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk">
                    确定
                </a-button>
            </template>
        </a-modal>
    </div>

</template>
<script>
const domainName = {
    '001':'前台',
    '002':'中台',
    '003':'开放',
    '004':'基础',
}
const columns = [
    {
        title: "所属领域",
        dataIndex: "domain",
        align: "center",
        scopedSlots: { customRender: 'domainNames' },
        width:80
    },

    {
        title: "类名",
        dataIndex: "classname",
        align: "center",
        width:400,
        ellipsis: true,
    },
    {
        title: "获取模式",
        dataIndex: "accessmode",
        align: "center",
        width:100,
        ellipsis: true,
    },
];

export default {
    data() {
        return {
            confirmLoading: false,
            isShow:false,
            columns:columns,
            domainName,
            selectedRowKeys: [],
            list:[],
            searchVal:'',
            searchDomain:'',
            pagination:{
                total:0,
                pageSize:10,
                current:1,
            },
            currentAppSelectSearchInput:'currentAppSelectSearchInput'

        }
    },

    methods: {
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        init(domain){
            this.searchDomain = domain;
            this.isShow = true;
            this.onSearch('');
        },
        handlePageChange(params_page){
            this.onModalInit(params_page)
        },
        onModalInit(pageNum){
            let that = this;
            let c_params = {
                domain:that.searchDomain,
                keyword:that.searchVal,
                pageSize:that.pagination.pageSize,
                page:pageNum,
                urlparams:false,
            }

            that.$store.dispatch({
                type: "servicekey/processorQueryClassListPage",
                params:c_params,
                showMsg: false
            }).then((res)=>{
                if(res.data.success == 1){
                    let result = res.data.data;
                    that.list = result.list;
                    that.pagination.total = result.totalRecords;
                    that.pagination.pageSize = result.pageSize;
                    that.pagination.current = result.page;
                }
                else{
                    that.message.error('获取列表失败')
                }
            })
        },


        onSearch(value){
            this.searchVal = value;
            this.onModalInit(1); 
        },
        handleOk(){
   
            let result = this.selectedRowKeys.length > 0 ? this.selectedRowKeys[0] : '';
            this.$emit('onModalHide',result);
            this.selectedRowKeys = [];
            this.isShow = false;
        },
        handleCancel(e) {
            e.preventDefault()
            this.$emit('onModalHide','');
            this.isShow = false;
        }
    },
    mounted() {
    },
    watch:{
        'isShow'(newVal){
            if(newVal){
                setTimeout(() => {
                    document.getElementById('currentAppSelectSearchInput').focus()
                }, 500);
                this.onModalInit(1);
            }
        }
    }

};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
